import type { CSSProperties } from "react";

/** Hauteur fixe du header (px) — alignée avec layout/Header */
export const HEADER_HEIGHT_PX = 72;

/** Largeur sidebar desktop — alignée avec SIDEBAR_WIDTH dans ui/sidebar/utils */
export const SIDEBAR_WIDTH_REM = "16rem";

export const layoutStyle: CSSProperties = {
  "--header-h": `${HEADER_HEIGHT_PX}px`,
  "--sidebar-w": SIDEBAR_WIDTH_REM,
} as CSSProperties;
